import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import "../../theme/styles.css";
import AppContainer from "../AppContainer";

const AboutScreen = () => {
  return (
    <AppContainer>
      <h1>
        <FormattedMessage id="AboutScreen.Title" />
      </h1>
      <FormattedHTMLMessage id="AboutScreen.Content" />
      <img
        alt="Orange County"
        className="map"
        src={require("../../images/home/orange_county.jpg")}
      />
    </AppContainer>
  );
};

export default AboutScreen;



// WEBPACK FOOTER //
// ./src/screens/general/AboutScreen.js